import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    card: {
        id: 'cards.list.card',
        defaultMessage: 'Card',
    },
    type: {
        id: 'cards.list.type',
        defaultMessage: 'Type',
    },
    status: {
        id: 'cards.list.status',
        defaultMessage: 'Status',
    },
    virtual: {
        id: 'cards.list.virtual',
        defaultMessage: 'Virtual',
    },
    physical: {
        id: 'cards.list.physical',
        defaultMessage: 'Physical',
    },
})
